import React, { useEffect } from 'react';
import { Box, Flex } from 'rebass/styled-components';
import { useParams, Redirect, useHistory, Switch, Route, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { trackEvent } from 'helpers/analytics';
import { useShareContactsMutation } from 'services/userV2';
import AllySignupLayout from './components/AllySignupLayout';
import { userSelector } from '../../redux/selectors';
import { SignUp } from './components/signUp';
import { Profile } from './components/profile';

export const AllySignup = () => {
  const user = useSelector(userSelector);
  const { networkSlug } = useParams();
  const network = user?.allyingCollections?.find((nc) => nc.slug === networkSlug);
  const [shareContacts, { isLoading: isShareContactsLoading }] = useShareContactsMutation();
  const { path, url } = useRouteMatch();

  const history = useHistory();

  useEffect(() => {
    if (network) {
      trackEvent('ally_onboarding:start', {
        collection_id: network?.id,
      });
    }
  }, [user, history, network]);

  if (!network) {
    return <Redirect to="/stay-tuned" />;
  }

  const step = [
    {
      title: 'Connect your LinkedIn (less than 2 minutes)',
      description: 'Your new and existing connections will stay automatically up to date.',
    },
    {
      title: `${network.name} finds meaningful intros`,
      description: `The ${network.name} team can search your contacts and send intro requests to you.`,
    },
    {
      title: 'Make the intro',
      description: `You choose which intros to make, helping both ${network.name} and your contacts.`,
    },
  ];

  const handleShareContacts = async () => {
    const { data } = await shareContacts({
      collectionId: network.id,
      share: true,
    });

    if (data) {
      history.push(`/onboarding/${network.slug}/linkedin/sync?ally=true`);
    }
  };

  return (
    <AllySignupLayout
      isShareContactsLoading={isShareContactsLoading}
      onShareContacts={handleShareContacts}
      user={user}
      network={network}
      isLoggedIn={user && user.onboardingCompleted}
      justifyContent="center"
      alignItems="center"
      height="100vh"
      steps={step}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          gap: '160px',
          flex: 1,
          height: '100%',
        }}
      >
        <Box maxWidth="400px" m="0px auto" pb="40px">
          <Switch>
            <Route exact path={`${path}`}>
              <SignUp routePath={url} />
            </Route>
            <Route exact path={`${path}/profile/:mode`}>
              <Profile user={user} network={network} />
            </Route>
          </Switch>
        </Box>
      </Flex>
    </AllySignupLayout>
  );
};

export default AllySignup;
